import type { PagedResponse } from './types';

/**
 * The page size a screen asks for when it wants every row the API will give in one page. The API holds each
 * list to its own configured ceiling and clamps anything larger, so no app needs to know what the ceiling is.
 * The largest value the API's `int` binds.
 */
export const LARGEST_PAGE = 2_147_483_647;

/** Every row of a paged list, read page by page: for the few lists small enough to be held whole. */
export async function fetchAllPages<T>(fetchPage: (page: number) => Promise<PagedResponse<T>>): Promise<T[]> {
  const all: T[] = [];
  for (let page = 1; ; page++) {
    const result = await fetchPage(page);
    all.push(...result.items);
    if (page >= result.totalPages) return all;
  }
}
